import { LEFTPANEL } from "../../actions/dashboard/";

export default function(state = false, action){
  switch (action.type) {
    case LEFTPANEL:
    return action.payload;
    default:
  }

  return state;
}
